export default __webpack_public_path__ + "static/media/home.1bb2e7d1.png";